import { createDataSourceOption, dictionaryTypeOtions } from './DictionaryBuilder.Helpers';
import { ReactComponent as RemoveIcon } from '../../Common/BootstrapIcons/close.svg';
import Dictionary from '../../../types/report/Dictionary';
import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import CustomIcon from '../../Common/BootstrapIcons/Custom/CustomIcon';
import EditableText from '../../Common/EditableText/EditableText';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import React from 'react';
import SelectList from '../../Common/SelectList/SelectList';
import ComponentType from '../../../types/report/ComponentType';
import ComponentChangeLogIconAndAction from '../../Common/Modals/ComponentChangeLogModal/ComponentChangeLogIconAndAction';
import CustomDropdown from '../../Common/Dropdown/CustomDropdown';
import CustomDropdownOption from '../../Common/Dropdown/CustomDropdownOption';

const getColumns = (
    onNameChange: (name: string, number: number) => void,
    onTypeChange: (isMultiResult: boolean, number: number) => void,
    onDataSourceChange: (dataSourceId: string, number: number) => void,
    onBusinessDescriptionChange: (businessDescription: string, number: number) => void,
    onRemoveClick: (number: number) => void,
    dataSources: IngestionConfig[],
    isReadOnly: boolean,
    reportConfigId: number,
    getDictionryReferences: (number: number) => Promise<CustomDropdownOption[]>,
    onDictionaryReferenceSelected: (option: CustomDropdownOption) => void

): ColumnDefinition<Dictionary>[] => {

    let columns: ColumnDefinition<Dictionary>[] = [
        {
            header: 'Reference',
            getContent: x => x.number.toString(),
            width: '8%'
        },
        {
            header: 'Dictionary Name',
            getContent: x => <EditableText disabled={isReadOnly} value={x.name} onChange={value => onNameChange(value, x.number)} multiline={true} />,
            width: '20%'
        },
        {
            header: 'Dictionary Type',
            getContent: x =>
                <SelectList
                    className="inline-select"
                    disabled={isReadOnly}
                    options={dictionaryTypeOtions}
                    value={x.isMultiResult.toString()}
                    onChange={((value, _) => { onTypeChange(value === true.toString(), x.number) })} />,
            width: '10%'
        },
        {
            header: 'Data Source',
            getContent: x =>
                <SelectList
                    disabled={isReadOnly}
                    className="inline-select"
                    options={dataSources.map(createDataSourceOption)}
                    value={x.dataSourceId?.toString()}
                    onChange={value => onDataSourceChange(value, x.number)} />,
            width: '12%'
        },
        {
            header: 'Business Description',
            getContent: x => <EditableText disabled={isReadOnly} value={x.businessDescription} onChange={value => onBusinessDescriptionChange(value, x.number)} multiline={true} style={{ width: '100%', height: '60px' }} />,
            width: '25%'
        },
        {
            header: '',
            getContent: x =>
                <div className='display-flex justify-content-end'>
                    <CustomDropdown
                        optionsPopupClassName='max-width-350px'
                        showOnlyDefaultTextAsSelected='References'
                        getOptions={() => { return getDictionryReferences(x.number) }}
                        value={x.name}
                        onOptionSelected={(option: CustomDropdownOption) => {
                            onDictionaryReferenceSelected(option);
                        }}
                    />
                    <button
                        className="custom-icon-button float-right"
                        onClick={() => onRemoveClick(x.number)}
                        disabled={isReadOnly}>
                        <CustomIcon icon={RemoveIcon} title={iconTooltip.remove} />
                    </button>
                    {x.id &&
                        <ComponentChangeLogIconAndAction
                            reportConfigId={reportConfigId}
                            id={x.id as number}
                            componentName={x.name}
                            componentType={ComponentType.Dictionary} />
                    }
                </div>,
            width: '25%'
        }
    ];

    return columns;
};

export { getColumns };
